<template>
  <div>

    <v-card>
      <v-card-title>Listado de Estados de Faena</v-card-title>
      <v-card-text>

        <botonera :botones="botones" alinear="right"
        @crear="dialog = !dialog"
        ></botonera>


        
      </v-card-text>
    </v-card>

    <datatable :cabeceras="estadoFaenasListHeaders" :items="estadoFaenasListBody" titulo="Listado de Estados Faenas" label="Escriba Para buscar Estado de Faena" icono="list" color_icono="azul"
    :tachar="false"
    :acciones="['editar','eliminar']"
    @editar="editTipoFaena($event)"
    @eliminar="deleteTipoFaena($event)">
    </datatable>

    <!-- <v-data-table 
        :headers="estadoFaenasListHeaders"
        :items="estadoFaenasListBody"
        class="elevation-1"
        no-data-text="No hay estados de faena"
        :search="search"
    >
      <template v-slot:[`item.actions`]="{item}">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              @click="editTipoFaena(item)"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar Tipo Faena</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              @click="deleteTipoFaena(item)"
              v-on="on"
            >
            mdi-delete
            </v-icon>
          </template>
          <span>Eliminar Tipo Faena</span>
        </v-tooltip>
      </template>
    </v-data-table> -->

    <!-- Modal Nuevo Tipo Faena -->
    <v-dialog
      v-model="dialog"
      width="800px"
      @click:outside = "closeModal"
    >
      <v-card>
        <v-card-title class="blue darken-1">{{ title }}</v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="6"
            >
              <v-text-field
                prepend-icon="mdi-barcode"
                placeholder="Nombre"
                v-model="estadoFaena.nombre"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
              <v-btn
                @click="closeModal"
              >Cerrar</v-btn>
              <v-btn
                color="primary"
                @click="saveTipoFaena"
              >Grabar</v-btn>
        </v-card-actions>
              
      </v-card>
    </v-dialog>
    <!-- / Modal -->
    
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      title: 'Nuevo Estado',
      color: 'green',
      snackbar: false,
      errors: [],
      validation_message: '',
      success: null,
      search: null,
      file: null,
      dialog: false,
      estadoFaenaIndex: -1,
      estadoFaena: {
        id: 0,
        nombre: '',
      },
      estadoFaenasListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'nombre',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "blue-grey darken-4 white-text"
        },
      ],
      estadoFaenasListBody: [],
      botones:[
        {boton:'crear',tooltip:'Nuevo Estado Faena'},
        //{boton:'cargar',tooltip:'Carga Masiva'},
        //{boton:'eliminar',tooltip:'Borrar Todo'}
      ]
    }),
    mounted() {
      this.loadTipoFaenas();
    },
    methods:{
      async loadTipoFaenas(){
        this.mostrarLoading('Cargando listado de estadoFaenas...')
        let url = `${this.base_url}estado_faenas`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.estadoFaenasListBody = response.data;
          this.ocultarLoading()
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading()
        });
      },
      async saveTipoFaena(){
        // validation
        this.errors = [];
        if(!this.estadoFaena.nombre){
          this.errors.push("Debe indicar nombre");
        }else if(this.estadoFaena.nombre.length > 20){
          this.errors.push("Tamaño máximo nombre: 20 caracteres");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}estado_faenas`;
        let estadoFaenaData = {
          'nombre': this.estadoFaena.nombre,
        };
        if(this.estadoFaena.id > 0){
          url = url + "/" + this.estadoFaena.id;
          await this.axios.put(url, estadoFaenaData, this.headers).then((response)=>{
            let index = this.estadoFaenasListBody.map(estadoFaena => {
              return estadoFaena.id;
            }).indexOf(this.estadoFaena.id);
            this.estadoFaenasListBody.splice(index, 1, response.data);
            this.showSnackBar(false);
          }).catch((error)=>{
            this.validation_message = error;
            this.showSnackBar(true);
          });
        }else{
          await this.axios.post(url, estadoFaenaData, this.headers).then((response)=>{
              this.estadoFaenasListBody.push(response.data);
              this.showSnackBar(false);
          }).catch((error)=>{
              this.errors = error.response.data;
              this.validation_message = this.errors.join();
              this.showSnackBar(true);
          });
        }
        this.cleanForm();
      },
      editTipoFaena(item) {
        this.estadoFaenaIndex = this.estadoFaenasListBody.indexOf(item);
        this.estadoFaena = Object.assign({}, item);
        this.dialog = true;
        this.title = "Editar Estado";
      },
      async deleteTipoFaena(item) {
        this.$confirm('Desea borrar este estadoFaena?').then(res => {
          if(res){
            let url = `${this.base_url}estado_faenas/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              const index = this.estadoFaenasListBody.indexOf(item);
              this.estadoFaenasListBody.splice(index, 1);
              this.showSnackBar(false);
            }).catch((error)=>{
              this.validation_message = error;
              this.showSnackBar(true);
            });
          }
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      closeModal(){
        this.cleanForm();
        this.dialog = false;
        this.error = null;
        this.title = "Nuevo Estado";
      },
      cleanForm(){
        this.estadoFaena = {
          id: 0,
          nombre: '',
        };
        this.dialog = false;
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['loading', 'base_url', 'headers']),
      
    },
    components:{
      
    }
  }
</script>